import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import StarBorderOutlinedIcon from '@material-ui/icons/StarBorderOutlined';
import { CardMedia } from '@material-ui/core';
import default_url from './damy/cam20024_20220315_13.mp4_100f_org.jpg';


function About() {
    const [image, setImage] = useState([])
    const name = 'Sapporo'

    useEffect(() => {
        axios.get(`/api/image/latest/${name}`, {responseType: 'blob',})
        .then(res => {
          if (res.data != null) {
            setImage([URL.createObjectURL(res.data)])
          }
        })
      }, [])


    return (
        <div>
            <img src={image} width='800'/>
        </div>
    )
}

export default About